import { CanActivateFn, Router } from '@angular/router';
import { RuntimeCacheService } from '../runtime-cache.service';
import { RequiredPermissionGuard } from './required-permission-guard';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const runtimeCacheService = inject(RuntimeCacheService);

    const data = (route.data as RequiredPermissionGuard) ?? new RequiredPermissionGuard();
    const requiredPermissions =
        data?.requiredPermissions?.map((e: string) => e.toLowerCase()) ?? [];

    if (!runtimeCacheService.isLogged()) {
        return router.createUrlTree(
            ['/auth/login'],
            { queryParams: { returnUrl: state.url } }
        );
    }

    try {
        const userRights = await runtimeCacheService.loadPermissions();
        const permissions = (userRights.permissions ?? []).map(x => x.toLowerCase());

        const hasPermission =
            requiredPermissions.length === 0 ||
            requiredPermissions.every(item => permissions.includes(item.toLowerCase()));

        if (hasPermission) {
            return true;
        }

        return router.createUrlTree(['/']);
    } catch {
        runtimeCacheService.resetAuthState();
        return router.createUrlTree(
            ['/auth/login'],
            { queryParams: { returnUrl: state.url } }
        );
    }
};